import React, { useState } from 'react';
import { Checkbox } from 'antd-mobile';
import { Button, Modal } from 'antd-mobile';
import PropTypes from 'prop-types';
import TermsParagraph from './TermsParagraph';

const TermsModal = ({ isChecked, setIsChecked }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const [isChecked, setIsChecked] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true); // 初始状态按钮不可点击

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsChecked(true); // 用户点击同意后，设置复选框为选中状态
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setIsChecked(false);
  };

  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

    // 检查是否滚动到底部，这里使用了 <= 1 的容差来处理可能存在的小数点差异
    if (scrollHeight - scrollTop <= clientHeight + 1) {
      setIsButtonDisabled(false);
    } else {
      setIsButtonDisabled(true);
    }
  };

  return (
    <>
      <Checkbox onClick={showModal} checked={isChecked}>
        我已閱讀並同意{' '}
        <span className="red" onClick={showModal}>
          服務條款
        </span>
      </Checkbox>
      <Modal
        title="服務條款"
        showCloseButton={true}
        visible={isModalVisible}
        onOk={handleOk}
        // onCancel={handleCancel}
        onClose={handleCancel}
        okButtonProps={{ disabled: isButtonDisabled }}
        // onScroll={handleScroll}
        content={
          <div>
            <div
              onScroll={handleScroll}
              style={{ overflowY: 'scroll', height: '300px' }}>
              {/* 模拟长文本 */}
              <p className="text-body font-normal">
                <TermsParagraph />
              </p>
            </div>
            <Button
              style={{ marginTop: '12px' }}
              block
              disabled={isButtonDisabled}
              onClick={handleOk}
              className="secondary-button">
              我已詳閱並同意條款
            </Button>
          </div>
        }></Modal>
    </>
  );
};

TermsModal.propTypes = {
  isChecked: PropTypes.bool,
  setIsChecked: PropTypes.func,
};

export default TermsModal;
